<template>
  <div
    :class="{
      [classes]: true,
      [sizeClasses]: true,
      'text-neutral-white': !lowContrast,
    }"
    class="flex items-center font-medium !text-[11px] rounded w-fit gap-1 leading-[16px] font-geist self-center flex-none"
  >
    <component :is="IconMap[iconLeft]" v-if="iconLeft" :class="iconClasses" />
    <slot></slot>
    <component :is="IconMap[iconRight]" v-if="iconRight" :class="iconClasses" />
  </div>
</template>

<script lang="ts" setup>
import * as icons from '@pulse/components/icons';
import { get } from '@pulse/utils/accessors';

import { BadgeType } from '~/types';

const IconMap: Record<string, any> = {
  ...icons,
};

type BadgeSize = 'small' | 'large';

const statusMap: Record<string, string | object> = {
  danger: 'bg-danger-700',
  info: 'bg-secondary-700',
  lowContrast: {
    danger: 'bg-danger-100 text-danger-700',
    neutral: 'bg-neutral-100 text-neutral-700',
    primary: 'bg-primary-100 text-primary-700',
    secondary: 'bg-secondary-100 text-secondary-700',
    success: 'bg-success-100 text-success-700',
    warning: 'bg-warning-100 text-warning-700',
  },
  neutral: 'bg-neutral-700',
  primary: 'bg-primary-700',
  secondary: 'bg-secondary-700',
  success: 'bg-success-700',
  warning: 'bg-warning-700',
};

const sizeMap: Record<string, string> = {
  large: 'py-1 px-2',
  small: 'p-1 px-2',
};

const iconSizeMap: Record<string, string> = {
  large: 'w-4 h-4',
  small: 'w-3 h-3',
};

const props = defineProps({
  iconLeft: {
    default: '',
    type: String as PropType<keyof typeof IconMap>,
  },
  iconRight: {
    default: '',
    type: String as PropType<keyof typeof IconMap>,
  },
  lowContrast: {
    default: false,
    type: Boolean,
  },
  size: {
    default: 'large',
    type: String as PropType<BadgeSize>,
  },
  type: {
    default: 'primary',
    type: String as PropType<BadgeType>,
  },
});

const classes = computed(() => {
  const accessorType: string = props.lowContrast ? `lowContrast.${props.type}` : props.type;

  return get(statusMap, accessorType);
});

const iconClasses = computed(() => {
  return `${iconSizeMap[props.size]} fill-current`;
});

const sizeClasses = computed(() => {
  return sizeMap[props.size];
});
</script>
